// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__1AzyN","children":"style_children__2Vhxm","text":"style_text__2CK_D"};